// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A9op","colBig":"styles_colBig__3JHSL","colSmall":"styles_colSmall__cdGv3"};